import PropTypes from 'prop-types'
import {Map} from 'immutable'

import AccountSettingsRow from './AccountSettingsRow'

import {isFuneralHome} from '../../../../../pro/src/lib/firmTools'

const ProfessionalPartnerInformation = ({
  userConfig,
  advisorContactCard,
  accountSetting,
  firm}) => {
  if (userConfig.get('client')) {
    const bodyText = () => {
      const nameText = isFuneralHome(firm) ?
        firm.get('name') :
        advisorContactCard.get('name')

      const firstSentence = `${nameText} is your Everplans professional partner.`

      if (accountSetting.get('is-write-access-enabled'))
        return `${firstSentence} See contact info and manage editing permissions.`
      else
        return `${firstSentence} Please contact your professional partner if you'd like to disassociate your account from your partner.`
    }

    return (
      <AccountSettingsRow
        title='Everplans professional partner'
        bodyText={bodyText()}
        url='/cm/account-settings/my-professional-partner'
      />
    )
  } else {
    return null
  }
}

ProfessionalPartnerInformation.propTypes = {
  accountSetting: PropTypes.instanceOf(Map),
  advisorContactCard: PropTypes.instanceOf(Map),
  firm: PropTypes.instanceOf(Map),
  userConfig: PropTypes.instanceOf(Map)
}

export default ProfessionalPartnerInformation
